import {LinearProgress} from '@mui/material'
import {memo} from 'react'

export const DashboardProgress = memo(() => {
  return <LinearProgress sx={{
    position: 'absolute',
    width: '100%',
  }}/>
})
